// Aviator — frontend GameModule. Dark-launch: games.is_locked=1, so only
// dev-PIN holders reach this page until the owner opens it.
import type { GameModule } from '../types';
import Page from './Page';

const aviator: GameModule = {
  id: 'aviator',
  displayName: 'Aviator',
  tag: 'Casino',
  theme: {
    gradient: 'from-sky-400 to-blue-800',
    emoji: '✈️',
    logo: '/games/aviator/Logo.png',
  },
  orientation: 'portrait',
  adminIcon: 'flight_takeoff',
  adminTheme: {
    headerFrom: 'from-sky-900', headerTo: 'to-blue-800',
    ring: 'ring-sky-400', accent: 'bg-sky-600', accentHover: 'hover:bg-sky-500',
    dot: 'bg-sky-400', softBg: 'bg-sky-900/30', rangeAccent: 'accent-sky-500',
    badgeClasses: 'bg-sky-600/20 text-sky-300 border-sky-600/30',
  },
  Page,
};

export default aviator;
